<template>
    <app-modal
        tabindex="-1"
        role="dialog"
        @modal-close="handleClose"
    >
        <div
            @keydown="handleKeydown"
            class="modal__box"
        >
            <div>
                <app-heading class="modal__ttl" element="h3" v-html="heading"></app-heading>

                <p class="text-80 px-8 my-16" v-html="text"></p>
            </div>

            <div class="modal__footer">
                <div class="flex items-center ml-auto">
                    <button
                        @click.prevent="handleClose"
                        class="btn btn--rounded btn--red mr-3"
                        v-html="cancelText"
                    >
                    </button>

                    <button
                        @click.prevent="handleConfirm"
                        class="btn btn--rounded btn--green"
                    >
                        <span v-html="actionText"></span>
                    </button>
                </div>
            </div>
        </div>
    </app-modal>
</template>

<script>
    import Modal from '@/components/Modal';
    import Heading from '@/components/Heading';

export default {
    components: {
        'app-modal': Modal,
        'app-heading': Heading
    },

    props: {
        heading: {
            type: String,
            default: 'Hold up!'
        },
        text: {
            type: String,
            default: 'You\'re about to delete something, do you want to continue?'
        },
        actionText: {
            type: String,
            default: 'I do!'
        },
        cancelText: {
            type: String,
            default: 'No!'
        }
    },

    methods: {
        /**
         * Stop propogation of input events unless it's for an escape or enter keypress
         */
        handleKeydown(e) {
            if (['Escape', 'Enter'].indexOf(e.key) !== -1) {
                return
            }

            e.stopPropagation()
        },

        /**
         * Execute the selected action.
         */
        handleConfirm(e) {
            this.$emit('confirm')
        },

        /**
         * Close the modal.
         */
        handleClose() {
            this.$emit('close')
        },
    },
}
</script>



// WEBPACK FOOTER //
// src/components/modals/ConfirmModal.vue